/**
 * Schema.org Organization markup for speer.io (site-wide JSON-LD).
 * @see speer_schema_markup.md
 */
export const SPEER_ORGANIZATION_SCHEMA = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': 'https://speer.io/#organization',
    name: 'Speer Technologies',
    legalName: 'Speer Technologies Inc.',
    alternateName: 'Speer',
    url: 'https://speer.io',
    logo: 'https://www.speer.io/logo.png',
    image: 'https://www.speer.io/og-image.png',
    slogan: 'Custom AI and software development. Toronto. 35+ patents granted.',
    description:
        'Toronto-based custom AI and software development firm, founded in 2019. Speer Technologies partners with founders, CTOs, and Chief Innovation Officers to design, build, and protect proprietary technology, from custom AI systems and patentable software to end-to-end product development. 35+ patents granted, 10+ patents pending. 40+ digital products shipped across Healthcare, Real Estate, Entertainment, Finance, and Transportation.',
    foundingDate: '2019',
    foundingLocation: {
        '@type': 'Place',
        address: {
            '@type': 'PostalAddress',
            addressLocality: 'Toronto',
            addressRegion: 'ON',
            addressCountry: 'CA',
        },
    },
    founder: {
        '@type': 'Person',
        name: 'Mathew Mozaffari',
        jobTitle: 'Founder',
        sameAs: [
            'https://www.linkedin.com/in/mathewmozaffari/',
            'https://www.tiktok.com/@mathewmozaffari',
        ],
    },
    address: {
        '@type': 'PostalAddress',
        streetAddress: '379 Shuter Street',
        addressLocality: 'Toronto',
        addressRegion: 'ON',
        postalCode: 'M5A 1X3',
        addressCountry: 'CA',
    },
    contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+1-365-975-9029',
        contactType: 'customer service',
        email: 'create@speer.io',
        areaServed: [ 'CA', 'US' ],
        availableLanguage: [ 'English' ],
    },
    numberOfEmployees: {
        '@type': 'QuantitativeValue',
        minValue: 40,
        maxValue: 100,
    },
    naics: '541511',
    sameAs: [
        'https://www.linkedin.com/company/speertech/',
        'https://www.crunchbase.com/organization/speer-technologies',
        'https://www.instagram.com/speertech/',
        'https://www.facebook.com/speertech',
    ],
    award: [
        'Canada\'s Top Growing Companies 2024 (#42, The Globe and Mail)',
        'Canada\'s Top Growing Companies 2025 (The Globe and Mail)',
    ],
    knowsAbout: [
        'Custom AI development',
        'Patentable software development',
        'Custom software development Toronto',
        'Healthcare technology',
        'Real estate technology',
        'Fintech development',
        'Entertainment technology',
        'Intellectual property strategy',
        'Product design',
        'End-to-end product development',
    ],
    keywords:
        'custom AI development Toronto, custom software development Toronto, patentable software, Toronto AI development firm, custom AI for healthcare, custom AI for real estate, intellectual property strategy, end-to-end product development, Mathew Mozaffari',
    areaServed: [
        { '@type': 'Country', name: 'Canada' },
        { '@type': 'Country', name: 'United States' },
    ],
} as const;
